<template>
  <div class="ui form" ref="form">
    <code-editor
      :title="$t('robot code editor')"
      v-model="object.code"
      :show_format="true"
    />
    <div class="ui error message"></div>
  </div>
</template>

<script>
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "RobotModalSourceCode",
  components: { CodeEditor },
  props: { robot_in: Object, projects: Array },
  data() {
    return {
      object: {
        code: "",
      },
    };
  },
  methods: {
    getData() {
      return this.object.code;
    },
    isValid() {
      return window.jQuery(this.$refs.form).form("validate form");
    },
    setCode(code) {
      this.object.code = code;
    },
  },
  computed: {},
  beforeMount() {
    let vm = this;
    if (
      vm.robot_in &&
      vm.robot_in.setup &&
      vm.robot_in.setup.general &&
      vm.robot_in.setup.general.code
    ) {
      vm.object.code = vm.robot_in.setup.general.code;
    }
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        project: ["empty"],
        name: ["empty"],
        path: ["empty"],
      },
    });

    if (vm.projects && vm.projects.length) {
      let vls = vm.projects.map((p) => {
        return { name: p, value: p };
      });
      window
        .jQuery(vm.$refs.project_dropdown)
        .dropdown({
          allowAdditions: true,
        })
        .dropdown("setup menu", { values: vls });

      if (vm.object.project) {
        window
          .jQuery(vm.$refs.project_dropdown)
          .dropdown("set selected", vm.object.project);
      }
    }
  },
};
</script>
